import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/product/product`;

export const productService = {
    listProduct: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-products`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    getProduct: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-product`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },
    createProduct: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-product`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateProduct: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-product`, params)
        .then((response) => {
            return response.data;
        });
    },
    deleteProduct: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-product`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    getProductUploadRequests: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/get-product-upload-requests`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    downloadExcel: async () => {
        try {
            // API çağrısı: Excel dosyasını al
            const response = await axios.get(`${GATEWAY_URL}/excel-file`, {
                responseType: "blob", // Dosya verisi için blob ayarı
                headers: {
                    Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // Excel MIME türü
                },
            });
    
            // Blob işlemleri
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "ProductImport.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Excel dosyası indirilemedi:', error);
        }
    }
}
